import { createStore, getActionIds } from '../helpers/redux';
import Immutable, { List, Set } from 'immutable';

import { ProjectActions } from '../actions/project';
import { ElementActions } from '../actions/element';
import { ElementTypeActions } from '../actions/elementType';
import { currentElementTypeIdSelector } from './elementTypes';

const projectActions = getActionIds(ProjectActions);
const elementActions = getActionIds(ElementActions);
const elementTypeActions = getActionIds(ElementTypeActions);

const initialState = Immutable.fromJS({
  loadingAll: [],
  loadedAll: [],
  loading: [],
  elementType: {},
  counts: {},
});

export const elementsByType = createStore(initialState, {
  // ['*']: (state, action) => {
  //   console.log('==> ', state.get('taggableType'));
  //   return state;
  // },

  [projectActions.resetReducers]: (state, action) => {
    return initialState;
  },

  [elementTypeActions.getElementsByType.begin]: (state, action) => {
    return state.set('loading', state.get('loading').push(action.args[0]))
      .set('loadingAll', state.get('loadingAll').push(action.args[0]));
  },

  [elementTypeActions.getElementsByType.success]: (state, action) => {
    const elementsList = [];

    if (action.result.entities.elements) {
      Object.keys(action.result.entities.elements).forEach(e => {
        if (action.result.entities.elements[e].type_id === action.args[0]) {
          elementsList.push(e);
        }
      });
    }

    const loadingState = state.get('loading');
    const index = state.get('loading').findIndex(a => a === action.args[0]);

    const loadingAllState = state.get('loadingAll');
    const loadingAllindex = state.get('loadingAll').findIndex(a => a === action.args[0]);

    const loadedAllState = state.get('loadedAll');
    const newLoadedAllState = loadedAllState.has(action.args[0]) ? loadedAllState :
      loadedAllState.push(action.args[0]);

    return state
      .mergeDeep({
        elementType: {
          [action.args[0]]: elementsList,
        },
      })
      .set('loading', loadingState.delete(index))
      .set('loadingAll', loadingAllState.delete(loadingAllindex))
      .set('loadedAll', newLoadedAllState);
  },

  [elementActions.createElement.success]: (state, action) => {
    const typeId = action.args[1].type_id;
    const elements = action.result.result;

    return state.updateIn(['elementType', typeId], arr =>
      Set(elements)
        .union(Set(state.getIn(['elementType', typeId])))
        .toList(),
    );
  },

  [elementActions.getElement.success]: (state, action) => {
    const typeId = action.args[1].type_id;
    const elements = [action.result.result];

    return state.updateIn(['elementType', typeId], arr =>
      Set(elements)
        .union(Set(state.getIn(['elementType', typeId])))
        .toList(),
    );
  },

  // [elementActions.deleteElement.success]: (state, action) => {
  //   const elementId = action.result.id;
  //   let typeElements = state.get('elementType');
  //   typeElements.map((typeId) => {
  //     typeElements = typeElements.deleteIn([typeId, elementId]);
  //   });

  //   return state.mergeDeep({
  //     loading: false,
  //     elementType: typeElements,
  //   });
  // },

  [elementActions.clientDeleteElements]: (state, action) => {
    const typeElements = state.get('elementType');
    const deleted = typeElements.withMutations(te =>
      typeElements.reduce(
        (p, c, i, a) =>
          p.setIn(
            [i],
            Set(state.getIn(['elementType', i], []))
              .subtract(action.elementIds)
              .toList(),
          ),
        te,
      ),
    );

    return state.setIn(['elementType'], deleted);
  },

  [elementTypeActions.getElementsByType.failure]: (state, action) => {
    return state.mergeDeep({
      loading: false,
    });
  },
});

export const filterElementsByType = (
  elementsByType,
  elementTypeId,
  taskTypeId,
  milestoneTypeId,
) => {
  if (elementsByType.size === 0) return List();

  if (elementTypeId === taskTypeId) {
    const taskElements = elementsByType.get(taskTypeId, List());
    const milestoneElements = elementsByType.get(milestoneTypeId, List());

    return taskElements.concat(milestoneElements);
  } else {
    return elementsByType.get(elementTypeId, List());
  }
};

export const shouldLoadElementsByType = (
  loading,
  loadedAll,
  typeId,
) => {
  const isLoadingState = loading.indexOf(typeId) !== -1;

  // TODO: This needs to be fixed - raninto a strange state where loadedAll is a Map in 1 instance
  if (!List.isList(loadedAll)) return true;

  const isLoadedState = loadedAll.indexOf(typeId) !== -1;

  if (!isLoadedState && !isLoadingState) return true;
  else if (isLoadedState || isLoadingState) return false;
  else return true;
};

export const elementTypeLoaded = (
  elementsByTypeState,
  typeId,
) => {
  return elementsByTypeState.has(typeId);
};

export const shouldLoadElementByTypeSelector = (state, props) => {
  const currentElementTypeId = currentElementTypeIdSelector(state, props);
  const loadingAll = state.elementsByType.get('loadingAll', List()).findIndex(a => a === currentElementTypeId) !== -1;
  const loadedAll = state.elementsByType.get('loadedAll', List()).findIndex(a => a === currentElementTypeId) !== -1;

  return !loadingAll && !loadedAll;
};

export const shouldLoadElementByType = (typeId, loading, map) => {
  const isLoadingState = loading.findIndex(a => a === typeId) !== -1;
  const isLoadedState = map.has(typeId);

  return !isLoadingState && !isLoadedState;
};

export const elementsByTypeLoadingSelector = state => {
  return state.elementsByType.get('loading');
};

export const elementsByTypeLoadedAllSelector = state => {
  return state.elementsByType.get('loadedAll');
};

export const elementsByTypeSelector = state => {
  return state.elementsByType.get('elementType');
};

export const filteredElementsSelector = (state, props) => {
  const currentElementTypeId = currentElementTypeIdSelector(state, props);

  return state.elementsByType.getIn(['elementType', currentElementTypeId]);
};



// WEBPACK FOOTER //
// ./src/reducers/elementsByType.js